module.exports = __webpack_public_path__ + "static/media/cvo-road-glide-bronze-armor.0c660297.png";